import { render, staticRenderFns } from "./Diecut.vue?vue&type=template&id=5cff7189&"
import script from "./Diecut.vue?vue&type=script&lang=js&"
export * from "./Diecut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports